<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Workflow</h3>
    </div>
  </div>
  <div class="row margin-0 card-body navi-hover" [perfectScrollbar]="{ wheelPropagation: false }">
    <div class="col" *ngIf="itemWorkflow">
      <formio
        #formio
        [form]="formSchema"
        (customEvent)="handleFormEvent($event)"
        (change)="onChange($event)"
        [submission]="formData"
        [readOnly]="isSubmitting || item.workflow_queue_id !== null"
      ></formio>
    </div>
    <div class="col" *ngIf="attachments && attachments.length > 0">
      <div *ngIf="attachments.length > 1">
        <div id="prevButton">
          <button mat-button color="primary" [disabled]="index === 0" pButton (click)="Previous()">
            Previous
          </button>
        </div>
        <div id="indexCount">{{ index + 1 }} of {{ attachments.length }}</div>
        <div id="nextButton">
          <button
            mat-button
            color="primary"
            [disabled]="index === attachments.length - 1"
            pButton
            (click)="Next()"
          >
            Next
          </button>
        </div>
      </div>
      <ngx-extended-pdf-viewer
        [src]="attachments[index].url"
        [useBrowserLocale]="true"
        [height]="'90vh'"
      ></ngx-extended-pdf-viewer>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-end">
      <div>
        <button mat-raised-button mat-dialog-close>Cancel</button>
        <div class="btn-group ml-3" *ngIf="item.workflow_queue_id === null">
          <button type="button" class="btn btn-primary" (click)="startWorkflow(false)">Save</button>
          <button
            type="button"
            class="btn btn-primary dropdown-toggle dropdown-toggle-split"
            style="width: 38px"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="svg-icon svg-icon-white">
              <span inlineSVG="./assets/media/svg/icons/Navigation/Angle-down.svg"></span>
            </span>
          </button>
          <div class="dropdown-menu">
            <a class="dropdown-item" (click)="startWorkflow(true)">Save and go to Workflow</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
